import {Table as UxTable,Card,Form} from '@deere/ux.uxframe-react'
import React from 'react'
import {getAnswerLabel,findAnswerIndex, getTranslation} from '../../utils/utils'
import { MARKET_SEGMENT, QUESTION_PROPRIETARY, QUESTION_TYPES } from '../../utils/surveyLiterals'
import PropiertaryInfReview from './PropiertaryInfReview'

export default function BsReviewSection({sectionSurvey,answers}){

    if(!sectionSurvey)
        return <></>

    const questions = sectionSurvey.questions.filter(qu => qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder)  ? 1 : -1)
    const questionTitle = questions ? questions.find(q => q.type === QUESTION_TYPES.OPEN_TITLE):null;
    const listQuestions = questions ? questions.filter(q => q.type === QUESTION_TYPES.TABLE_BS):null;
    const colNames = listQuestions[0] && listQuestions[0].dependentQuestions?listQuestions[0].dependentQuestions.map(q => getTranslation(q,'text')):[];
    const propQuestion = sectionSurvey.questions.filter(qu => qu.text === QUESTION_PROPRIETARY)[0];
    const generalQuestions = questions.filter(q=> (q.type === QUESTION_TYPES.RADIO || q.type === QUESTION_TYPES.OPEN ||  q.type === QUESTION_TYPES.OPTION));
    const marketSegHeader = questions ? questions.find(q => q.type === MARKET_SEGMENT) : null;

    const propComments = propQuestion ? findAnswerIndex(propQuestion.id, answers) >= 0 ? answers[findAnswerIndex(propQuestion.id, answers)].answer : '' : '';
    function createRow(question,index){
        //Remove row with no answer in the table
        if(question.dependentQuestions[0]) {
            if(findAnswerIndex(question.dependentQuestions[0].id,answers) <= 0 && findAnswerIndex(question.dependentQuestions[1].id,answers) <= 0)
                return <></>;
        }
        return <tr key={index}>
                    <td className='p-1'>{getTranslation(question,'text')}</td>
                    {
                        question.dependentQuestions.sort((a, b) => (a.showOrder > b.showOrder)  ? 1 : -1).map(dq =>
                            <td key={dq.id}>
                                {dq.type === 'PERC_SALES'?<h6>{getAnswerLabel(dq,answers)}</h6>:<></>}
                                {dq.type === 'OPTION'?<h6>{getAnswerLabel(dq,answers)}</h6>:<></>}
                            </td>
                        )
                    }   
                </tr> 
    }

    const createDependentRow = (question, index) => {
        let label = getAnswerLabel(question,answers);
        return label === '-'?null:<Form.Row key={index}>
                    <Form.Group className='mb-4 pl-4'>
                        <Form.Label className="uxf-label">{getTranslation(question,'text')}</Form.Label>
                        <h6>{label}</h6>
                    </Form.Group>
                </Form.Row>
    };

    return (<div>    
                {propComments? <PropiertaryInfReview section={sectionSurvey} answer={propComments}/>:null}    
                {!propComments? <Card>
                    <Card.Body>
                    <Card.Title className='pb-3'>
                        {getTranslation(sectionSurvey,'description')}
                    </Card.Title>
                    {
                        generalQuestions && generalQuestions.map((q,idx) => !q.idQuestionDepends 
                            ? 
                                <Form.Row key={idx}>
                                    <Form.Group>
                                        <Form.Label className="uxf-label">{getTranslation(q,'text')}</Form.Label>
                                        <h6>{getAnswerLabel(q,answers)}</h6>
                                    </Form.Group>
                        </Form.Row> : createDependentRow(q, idx))
                    }
                    <UxTable striped hover size="sm" >
                        <caption>{getTranslation(questionTitle,'text')}</caption>
                        <thead>
                            <tr>
                                {marketSegHeader ? <th className ='p-1' scope='col'>{getTranslation(marketSegHeader,'text')}</th> : <th className ='p-1' scope='col'></th>}
                                {
                                    colNames?colNames.map(qt => 
                                        <th scope="col" className="p-1 text-center" key={qt}>{qt}</th>):<></>
                                    
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                listQuestions.map((data,index)=>createRow(data,index))
                            }
                        </tbody>
                    </UxTable>
                    </Card.Body>
                </Card>:null
                }
            </div>)
}   